
<form [formGroup]="geoObjectCategoryForm" class="example-form settings-form">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.settingForm.title' | translate}}</mat-label>
        <input formControlName="title" matInput type="text" required>
    </mat-form-field>

    <div>
        <button [disabled]="geoObjectCategoryForm.invalid || updateRight" class="my-4 first-stt-btn w-100" mat-raised-button type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="isCreate || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
    </div>

</form>